import React from 'react'
import { Link } from 'react-router-dom'
const resetScroll = ()=>window.scrollTo(0,0);

function Card({title, icon, children, button}) {
    return (
        <div className="card-component">
            <div className="card-header">
                <h4>{title}</h4>
            </div>
            
            <div className="card-icon">
                {icon}
            </div>
            <div>
                {children}
            </div>
            <div className="card-button-container">
                {
                    button && <button className="card-button"><Link to={button} onClick={resetScroll}>Scopri di più</Link></button>
                }
            </div>
        </div>
    )
}

export default Card
